module.exports = __webpack_public_path__ + "img/Frame6.116e9956.png";